var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV1EmptyStateGenericIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "248px",
    height: "248px",
    viewBox: "0 0 248 248",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "empty icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bar-chart-V1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V1/Empty-states-V2",
    transform: "translate(-414.000000, -1212.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty-icon",
    transform: "translate(414.000000, 1212.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F1F1F1",
    cx: 124,
    cy: 124,
    r: 124
  }), /*#__PURE__*/React.createElement("g", {
    id: "Empty-icon",
    transform: "translate(56.554802, 37.315651)",
    fill: "#A1A1A1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.986623,42.3438196 C72.0439572,42.3438196 75.2622163,39.1323273 75.2622163,35.0682264 L75.2622163,7.66464233 C75.2622163,3.60730817 72.0507239,0.389049126 67.986623,0.389049126 C63.9292889,0.389049126 60.7110298,3.60054144 60.7110298,7.66464233 L60.7110298,34.9041331 C60.7110298,38.9614672 63.9291197,42.3448346 67.986623,42.3448346 L67.986623,42.3438196 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0778982,44.0355033 C30.2607573,46.9100122 32.970124,48.6016959 35.844633,48.6016959 C36.8622822,48.6016959 37.7081917,48.4298885 38.7191419,48.0928713 C42.4394927,46.572995 44.3030514,42.1719784 42.6113677,38.4516276 L32.1242822,13.248924 C30.6044059,9.52857325 26.3752644,7.6650145 22.4830385,9.35669819 C18.7626878,10.8765745 16.899129,15.2775911 18.5908127,18.9979419 L29.0778982,44.0355033 Z",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2544425,48.0921608 C98.1002844,48.429178 99.1180013,48.6009854 100.128951,48.6009854 C103.00346,48.6009854 105.712861,46.9093017 106.895686,44.0347928 L117.382772,18.8320892 C118.902648,15.1117384 117.210964,10.8825292 113.490546,9.19084552 C109.604918,7.82956458 105.204003,9.69307258 103.684025,13.4134572 L93.1969392,38.6161608 C91.6704654,42.3431091 93.5339564,46.5723183 97.2542734,48.0922961 L97.2544425,48.0921608 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.144774,108.319483 L115.181215,66.536588 C113.998356,63.9990625 111.460864,62.3073788 108.586355,62.3073788 L27.3855379,62.3073788 C24.5110289,62.3073788 21.9735034,63.9990625 20.7906782,66.536588 L0.827118956,108.319483 C0.318290953,109.337133 0.153081124,110.348151 0.153081124,111.530976 L0.153081124,153.823071 C0.153081124,157.880407 3.36457682,161.098665 7.42867771,161.098665 L128.556613,161.098665 C132.613947,161.098665 135.832206,157.887172 135.832206,153.823071 L135.832206,111.530976 C135.825592,110.519924 135.653784,109.330434 135.14496,108.319483 L135.144774,108.319483 Z M32.1246205,77.0233352 L104.021177,77.0233352 L116.53693,103.244432 L19.4376695,103.244432 L32.1246205,77.0233352 Z",
    id: "Fill-4"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV1EmptyStateGenericIcon);
export default __webpack_public_path__ + "static/media/V1Empty-state-generic-icon.c17cf7e03d15f623c28e433c63761795.svg";
export { ForwardRef as ReactComponent };